import { generateUUID } from '@thoughtspot/js-util';
import _ from 'lodash';
import { AxisTypes } from '../types/prism';
export const DEFAULT_AXIS_PROPERTIES = {
    __typename: 'AxisProperties',
    axisType: null,
    format: null,
    isOpposite: null,
    linkedColumns: [],
    name: null,
    yAxisRange: null,
    customProps: null,
};
export function generateAxis(axisColumnIdOrIds = [], axisType, additionalAxisProperties = {}) {
    const properties = {
        ...DEFAULT_AXIS_PROPERTIES,
        linkedColumns: _.castArray(axisColumnIdOrIds),
        axisType,
    };
    if (axisType === AxisTypes.Y) {
        Object.assign(properties, _.pick(additionalAxisProperties, [
            'format',
            'name',
            'yAxisRange',
            'isOpposite',
            'customProps',
        ]));
    }
    return {
        __typename: 'AxisObj',
        id: generateUUID(),
        properties,
    };
}
export function generateAxes(columns, axisType, options = {}) {
    if (axisType === AxisTypes.X ||
        (axisType === AxisTypes.Y && options.isLinkColumns)) {
        return [
            generateAxis(columns, axisType, {
                ...DEFAULT_AXIS_PROPERTIES,
                ...options.additionalProperties,
                isOpposite: false,
            }),
        ];
    }
    return columns.map((col, idx) => generateAxis(col, axisType, {
        isOpposite: idx !== 0,
    }));
}
//# sourceMappingURL=chart-axis.js.map